module.exports = __webpack_public_path__ + "img/SketchPng602736a8b06d297a46772402a4247e5d6c06e899eb10ae4f8509a34d08147636.2ebfcbae.png";